import { render, staticRenderFns } from "./ManageSession.vue?vue&type=template&id=2895f6e7"
import script from "./ManageSession.vue?vue&type=script&lang=js"
export * from "./ManageSession.vue?vue&type=script&lang=js"
import style0 from "./ManageSession.vue?vue&type=style&index=0&id=2895f6e7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports